import { v1 as uuidv1 } from 'uuid'
import { v4 as uuidv4 } from 'uuid'

const DEVICE_ID_STORAGE = "deviceId"
const DEVICE_KEY_STORAGE = "deviceKey"

export const setDeviceId = () => {
  if (!localStorage.getItem(DEVICE_ID_STORAGE)) {
    localStorage.setItem(DEVICE_ID_STORAGE, uuidv1())
  }
}

export const getDeviceId = () : string => {
  if (!localStorage.getItem(DEVICE_ID_STORAGE)) {
    localStorage.setItem(DEVICE_ID_STORAGE, uuidv1())
  }

  return localStorage.getItem(DEVICE_ID_STORAGE) ?? ''
}

export const setDeviceKey = (forceRefresh = false) => {
  if (!localStorage.getItem(DEVICE_KEY_STORAGE) || forceRefresh) {
    localStorage.setItem(DEVICE_KEY_STORAGE, uuidv4())
  }
}

export const getDeviceKey = () : string => {
  if (!localStorage.getItem(DEVICE_KEY_STORAGE)) {
    localStorage.setItem(DEVICE_KEY_STORAGE, uuidv4())
  }

  return localStorage.getItem(DEVICE_KEY_STORAGE) ?? ''
}

export const clearStorage = () => {
  const deviceId = localStorage.getItem(DEVICE_ID_STORAGE) ?? uuidv1()
  const devicekey = localStorage.getItem(DEVICE_KEY_STORAGE) ?? uuidv4()
  localStorage.clear()
  localStorage.setItem(DEVICE_ID_STORAGE, deviceId)
  localStorage.setItem(DEVICE_KEY_STORAGE, devicekey)
}